import { render } from "./AppMenu.vue?vue&type=template&id=02354244&scoped=true"
import script from "./AppMenu.vue?vue&type=script&lang=js"
export * from "./AppMenu.vue?vue&type=script&lang=js"

import "./AppMenu.vue?vue&type=style&index=0&id=02354244&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-02354244"

export default script